import { H2, P, theme } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import ProductTile, { ProductProps } from './components/product-tile';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';
import WrappedSection from '../../../../components/sections/wrapped-section';

const { media } = theme;

const Subtitle = styled(P)`
  margin: 0 auto;
  max-width: 600px;
`;

const TileWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 2rem;
  flex-direction: column;

  @media (min-width: ${media.md}) {
    align-items: normal;
    flex-direction: row;
    justify-content: center;
  }
`;

type Props = {
  title: string;
  subtitle?: string;
  content: ProductProps[] | null;
};

const PopularProductsSection = ({ title, subtitle, content }: Props) => {
  if (isEmpty(content)) {
    return null;
  }
  return (
    <WrappedSection withBorder withWide>
      <H2 variant="center">{title}</H2>
      <Subtitle variant={['center', 'marginBottomSpacer8']}>{subtitle}</Subtitle>

      <TileWrapper>
        {uncapFpIterator(map)(
          (product: ProductProps, index: number) => (
            <ProductTile key={index} {...product} />
          ),
          content,
        )}
      </TileWrapper>
    </WrappedSection>
  );
};

export default PopularProductsSection;
